module.exports = __webpack_public_path__ + "static/media/about-image1.dd746c69.jpeg";